import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import './Right.css';
import { useParams } from "react-router-dom";
import Pagination from '../../../CommonUI/Pagination/Pagination';
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'
function CorporateAction() {
    const [showResults, setShowResults] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [co_code, setco_code] = useState([]);
    const [setTextval, setText] = useState([]);
    const [compCode, setCompCode] = useState('');
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    const { getCompName } = useParams();
    const [nameCom, setNameCom] = useState([]);
    const [data, setData] = useState([]);
    // const [valuebtn, setValueBtn] = useState("desc");
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [corptype, settype] = useState('Rights');
    const [currentPage, setCurrentPage] = useState(1);
    // const [groupValue, setGroupValue] = useState("BSE");
    // const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    // const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    // useEffect(() => {
    //     setTimeout(() => {
    //         eleBtn.classList.add('active');
    //         eleLi.classList.add('active');
    //     })
    // }, [])
    useEffect(() => {
        setloadingshow(true)
        if(co_code != ''){
        // if (groupValue === "BSE") {
        const getUrl = BaseURL + "CorporateAction";
        fetch(`${getUrl}/${corptype}/-/-/${co_code}/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                //console.log(getData, "getData")
                setloadingshow(false)
            })
            .catch((error) => {
            });
        }
        // }
        //else {
        //     const getUrl = BaseURL + "DayUpandDown";
        //     fetch(`${getUrl}/${groupValue}/${groupIndexNSE}/-/${valuebtn}`)
        //         .then((response) => response.json())
        //         .then((data) => {
        //             getData = data.data;
        //             setData(getData);
        //             //console.log(getData, "getData")
        //         })
        //         .catch((error) => {
        //         });
        // }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [co_code]);


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);
    // const onChangeHandler = event => {
    //     let matches = [];
    //     setText(event.target.value);
    //     if (setTextval.length > 1) {
    //         Loadcompany(setTextval);
    //     }
    //     else {
    //         DataFilter = [];
    //         setSuggestions(DataFilter);
    //     }

    // };
    // function Loadcompany(setTextval) {
    //     setShowResults(true);
    //     const getSectorListUrl = BaseURL + "companysearch/" + setTextval;

    //     fetch(`${getSectorListUrl}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             const myrepo = data.data;

    //             getval = myrepo;
    //             for (var i = 0; i < getval.length; i++) {
    //                 DataFilter.push({
    //                     CompName: getval[i]['lname'],
    //                     COCODE: getval[i]['Co_Code'],
    //                     Exchange: getval[i]['Exchange']
    //                 });
    //             }

    //             matchcomp = DataFilter;
    //             setSuggestions(matchcomp);

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }
    // const companyClick = (paramcode, paramname, paramexchange) => {
    //     setShowResults(false);
    //     setCompCode(paramcode);
    // }

    // const handleClick = () => {
    //     const getUrl = BaseURL + "CorporateAction";
    //     alert(`${getUrl}/Rights/${compCode}/-/-/5`)
    //     fetch(`${getUrl}/Rights/${compCode}/-/-/5`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             getData = data.data;
    //             setData(getData);
    //             //console.log(getData, "getData")
    //         })
    //         .catch((error) => {
    //         });

    // }

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Rights</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='share-loser-sc'>
                            <div className='score-header'>
                                <h2><span>Rights</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Rights"/>
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom :''}</h4>
                            </div>
                            <div className="table-class">
                            {/* <div>
                                <div className='quotes-main-comp'>
                                    <input type="text" placeholder='Enter Company Name' onChange={onChangeHandler} ></input>
                                    {showResults ?
                                        <div className="suggestion">
                                            {suggestions && suggestions.map((suggestion, i) =>
                                                <div className="suggestion col-md-12 justify-content-md-center padd-content" onClick={() => companyClick(suggestion.COCODE, suggestion.CompName, suggestion.Exchange)}>{suggestion.CompName}</div>
                                            )}
                                        </div> : ''}
                                </div>
                                <div className='get-quote-btn'>
                                    <button className="goComp-comp" onClick={handleClick}>GO</button>
                                </div>
                            </div>
                            <hr className="hrRight"></hr> */}
                            <div className='Right-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>

                                            <th className="text-left">Announcement Date</th>
                                            <th className="text-left">Record Date</th>
                                            <th className="text-left">Rights Date</th>
                                            <th className="text-center">Ratio</th>
                                            <th className="text-right">Premium</th>
                                            <th className="text-center">Remarks</th>


                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ AnnouncementDate, recorddate, RightDate, RightsRatio, premium, remark }) => (
                                                <tr>
                                                    <td className="text-left">{(AnnouncementDate != null) ? (format(parseISO(AnnouncementDate), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-left">{(recorddate != null) ? (format(parseISO(recorddate), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-left">{(RightDate != null) ? (format(parseISO(RightDate), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-center">{RightsRatio}</td>

                                                    <td className="text-right">{premium}</td>
                                                    <td className="text-center">{remark}</td>
                                                </tr>
                                            )
                                        )
                                        }
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                </div>
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default CorporateAction;
